import React from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';

import MobileNavList from './MobileNavList';
import MobileNavMenuListItem from './MobileNavMenuListItem';
import Group from './MobileNavLinkGroup';
import { HeadingStyles, HeadingLinkStyles } from './MobileNavMenuHeadingStyles';

const MobileNavMenuSingleLink = ({ link, analytics, onNavListItemClick }) => (
  <Group>
    <h3 className={cx(HeadingStyles, HeadingLinkStyles)}>
      <MobileNavList className="heading-link__list">
        <MobileNavMenuListItem
          key={link.url}
          clickHandler={(e) => onNavListItemClick(e, { analytics, ...link })}
          {...link}
        />
      </MobileNavList>
    </h3>
  </Group>
);

MobileNavMenuSingleLink.defaultProps = {
  onNavListItemClick: null,
  analytics: null,
};

MobileNavMenuSingleLink.propTypes = {
  onNavListItemClick: PropTypes.func,
  analytics: PropTypes.shape({
    event: PropTypes.string,
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  }),
  link: PropTypes.shape({
    url: PropTypes.string,
    label: PropTypes.string,
    clickAction: PropTypes.string,
  }).isRequired,
};

export default MobileNavMenuSingleLink;
